import { nextTick, } from 'vue'
export function useTrapKeyboard (selector = '.v-dialog--active') {
    const trapKeyboard = function (newValue,oldValue,closeFn,focusLast = true) {
        if(newValue !== oldValue && newValue) {
            globalThis.focusedElementBeforeModal = document.activeElement

            nextTick(()=>{

                let modal = document.querySelector(selector)

                if(!modal) {
                    return
                }

                // Find all focusable children
                let focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]'
                let focusableElements = modal.querySelectorAll(focusableElementsString)
                // Convert NodeList to Array
                focusableElements = Array.prototype.slice.call(focusableElements)

                let firstTabStop = focusableElements[0]
                let lastTabStop = focusableElements[focusableElements.length - 1]

                // Focus first child
                firstTabStop.focus()

                globalThis.trapTabKey = (e) => {
                    // Check for TAB key press
                    if (e.keyCode === 9 || [ 'Tab', ].includes(e.key)) {

                        // SHIFT + TAB
                        if (e.shiftKey) {
                            if (document.activeElement === firstTabStop) {
                                e.preventDefault()
                                lastTabStop.focus()
                            }

                            // TAB
                        } else {
                            if (document.activeElement === lastTabStop) {
                                e.preventDefault()
                                firstTabStop.focus()
                            }
                        }
                    }

                    // ESCAPE
                    if (closeFn && (e.keyCode === 27 || [ 'Escape','Esc', ].includes(e.key))) {
                        e.preventDefault()
                        e.stopPropagation()
                        closeFn()
                    }
                }

                modal.addEventListener('keydown', globalThis.trapTabKey)

            })

        } else if(newValue !== oldValue && !newValue && typeof oldValue !== 'undefined') {

            let modal = document.querySelector(selector)
            modal && modal.removeEventListener('keydown', globalThis.trapTabKey)
            focusLast && globalThis.focusedElementBeforeModal && globalThis.focusedElementBeforeModal.focus()
        }
    }

    return {
        trapKeyboard,
    }
}